import Prismic from 'prismic-javascript'

const apiEndpoint = `${process.env.PRISMIC_API_ENDPOINT}`
const accessToken = `${process.env.PRISMIC_ACCESS_TOKEN}`

export default Prismic.client(apiEndpoint, { accessToken })